const RESUME_LS_RECORD = 'resume_last_search_record';

export default RESUME_LS_RECORD;
